import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';

const styles = (theme) => ({
    smallButton: {
        minWidth: 0,
        padding: theme.spacing(0.5),
        borderRadius: '50%',
        backgroundColor: 'white',
    },
});

class SmallButton extends React.Component {
    render() {
        const { icon, classes, className, ...rest } = this.props;
        return (
            <Button onClick={this.props.onClick} className={classNames(className, classes.smallButton)} {...rest}>
                {icon}
            </Button>
        );
    }
}

export default withStyles(styles)(SmallButton);
